(function ($) {
  initMenuAccesibility($("#menu-ce-menu"));

  function initMenuAccesibility(menu) {
    if (!menu.length) return;
    if (!menu.is(":visible")) return;
    if (!menu.is("ul")) return;
    console.log("initMenuAccesibility", menu);

    const firstLink = $(menu).find("> li:first-child a");

    $(menu)
      .find("li a")
      .each(function () {
        const link = $(this);
        if (firstLink.length && link.is(firstLink[0])) {
          link.attr("tabindex", "0");
        } else {
          link.attr("tabindex", "-1");
        }
      });
    $(menu)
      .find("li ul")
      .each(function () {
        const link = $(this);
        link.attr("tabindex", "-1");
      });

    const closeMenu = function () {
      const active = menu.find("li.active");
      console.log("active", active);

      if (active.length) {
        $(active).trigger("mouseleave");
        console.log("active", active);
        console.log("mouseleave", active);
        return;
      }
    };

    $(document).on("focusin", function (e) {
      console.log("focusin", e.target, menu.has($(e.target)).length);
      if (!menu.has($(e.target)).length) {
        closeMenu();
      }
    });

    $(document).on("keydown", function (e) {
      if (!menu.is(":visible")) return;
      if (!menu.has($(e.target)).length) return;

      if (e.key == "Enter" || e.key == " ") {
        e.preventDefault();
        console.log("Enter or Space pressed for", menu.attr("id"));
        const link = $(e.target);
        const submenu = link.parent().find("> ul");
        if (submenu.length) {
          $(link).trigger("mouseenter");
          const submenu_first_link = submenu.find("li:first-child a");
          submenu_first_link.attr("tabindex", "0");
          submenu_first_link.focus();
        } else {
          window.location.href = link.attr("href");
        }
      }

      if (e.key == "Escape") {
        e.preventDefault();
        console.log("Escape pressed for", menu.attr("id"));
        const parents = $(e.target).parentsUntil(menu);
        if (!parents.length) return;

        const lastParent = parents[parents.length - 1];
        $(lastParent).trigger("mouseleave");
        $(lastParent).find("a").attr("tabindex", "-1");
        $(lastParent).find("> a:first-child").attr("tabindex", "0").focus();
      }
      function checkIfInSubmenu(element) {
        if (!element.length) return false;
        if ($(element).is(menu)) return false;

        const ul_parents = $(element).parentsUntil(menu, "ul");
        if (!ul_parents.length) return false;
        if ($(ul_parents[0]).is(menu)) return false;
        return true;
      }

      if (e.key == "ArrowLeft") {
        e.preventDefault();
        console.log("ArrowLeft pressed for", menu.attr("id"));
        const link = $(e.target);

        const inSubmenu = checkIfInSubmenu(link);
        if (inSubmenu) {
          const submenu = link.parents("ul")[0];
          const top_li = link.parents("li")[1];

          let prev_li = $(top_li).prev("li");

          if (!prev_li.length) {
            prev_li = $(submenu).find("> li:last-child");
          }

          let prev_link = prev_li.find("> a");
          closeMenu();
          prev_link.trigger("mouseenter");

          const prev_link_submenu_link = prev_li.find("> ul li:first-child a");
          if (prev_link_submenu_link.length) {
            prev_link = prev_link_submenu_link;
          }

          prev_link.focus();
        } else {
          const parent = link.parent();
          if (parent.prev().length) {
            const prev = parent.prev().find("> a");
            prev.focus();
          } else {
            const prev = parent.parent().find("> li:last-child a");
            prev.focus();
          }
        }
      }

      if (e.key == "ArrowRight") {
        e.preventDefault();
        console.log("ArrowRight pressed for", menu.attr("id"));
        const link = $(e.target);

        const inSubmenu = checkIfInSubmenu(link);
        if (inSubmenu) {
          const submenu = link.parents("ul")[0];
          const top_li = link.parents("li")[1];

          let next_li = $(top_li).next("li");

          if (!next_li.length) {
            next_li = $(submenu).find("> li:first-child");
          }

          let next_link = next_li.find("> a");
          closeMenu();
          next_link.trigger("mouseenter");

          const next_link_submenu_link = next_li.find("> ul li:first-child a");
          if (next_link_submenu_link.length) {
            next_link = next_link_submenu_link;
          }

          next_link.focus();
        } else {
          const parent = link.parent();
          if (parent.next().length) {
            const next = parent.next().find("> a");
            next.focus();
          } else {
            const next = parent.parent().find("> li:first-child a");
            next.focus();
          }
        }
      }

      if (e.key == "ArrowDown") {
        e.preventDefault();
        console.log("ArrowDown pressed for", menu.attr("id"));
        const link = $(e.target);
        const submenuParent = link.parents(".sub-menu");

        if (submenuParent.length) {
          const parent = link.parent();
          if (parent.next().length) {
            const next = parent.next().find("> a");
            next.focus();
          } else {
            const next = parent.parent().find("> li:first-child a");
            next.focus();
          }
        } else {
          const parent = link.parent();
          const submenu = parent.find("> ul");
          if (submenu.length) {
            $(link).trigger("mouseenter");
            const submenu_first_link = submenu.find("li:first-child a");
            submenu_first_link.attr("tabindex", "0");
            submenu_first_link.focus();
          }
        }
      }
      if (e.key == "ArrowUp") {
        e.preventDefault();
        console.log("ArrowUp pressed for", menu.attr("id"));
        const link = $(e.target);
        const submenuParent = link.parents(".sub-menu");

        if (submenuParent.length) {
          const parent = link.parent();
          if (parent.prev().length) {
            const prev = parent.prev().find("> a");
            prev.focus();
          } else {
            const prev = parent.parent().find("> li:last-child a");
            prev.focus();
          }
        } else {
          const parent = link.parent();
          const submenu = parent.find("> ul");
          if (submenu.length) {
            $(link).trigger("mouseenter");
            const submenu_first_link = submenu.find("li:last-child a");
            submenu_first_link.attr("tabindex", "0");
            submenu_first_link.focus();
          }
        }
      }
    });
  }

  //notif bar
  const notif = document.getElementById('notif');
  if(notif){
    let name = notif.textContent.toLowerCase().replace(/\W/g, '');
    if (!sessionStorage.getItem(name)) {
      $("#notif").removeClass("d-none");
      $("#notif").slideDown("slow");
    } else {
      $("#notif-show").show();
    }

    $("#notif .btn-close").on("click", function (e) {
      e.preventDefault();
      $("#notif").slideUp();
      $("#notif").addClass("d-none");
      $("#notif-show").show();
      // Save data to sessionStorage
      sessionStorage.setItem(name, "closed");
    });
    
    $("#notif-show").on("click", function (e) {
      e.preventDefault();
      $("#notif").removeClass("d-none");
      $("#notif").slideDown("slow");
      $("#notif-show").hide();
      // Save data to sessionStorage
      sessionStorage.removeItem(name);
    });
  }
})(jQuery);